import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter} from '@angular/core';
import * as go from 'gojs';
import {Data} from '../lineage-path/class/data';
import {Model} from '../lineage-path/class/model';
import {Schema} from '../lineage-path/class/schema';

import {LineageDataService} from './lineage-service/data.service';
import {LineageJsPlumbService} from './lineage-service/jsPlumb.service';

@Component({
    selector: 'app-lineage-path',
    templateUrl: './lineage-path.component.html',
    styleUrls: ['./lineage-path.component.scss']
})
export class LineagePathComponent implements OnInit {

    data: Data;
    myModel: Model;
    schema: Schema;
    pY: number;
    models = [];
    schemas = [];
    @Input() tables;
    @Input() relationTables = [];
    @Input() table: any;
    @Input() databaseConnectionName: any;
    @Input() type: any;
    @Input() view: any;
    relations = [];
    pos_x = 10;
    pos_y = 50;
    id = 0;


    constructor(private dataService: LineageDataService, private jsPlumbService: LineageJsPlumbService, private el: ElementRef) {
        //this.myModel = new Model();
        //this.data = this.dataService.data;
        this.data = new Data();
        //this.jsPlumbService.init();
        //console.log(this.data);
    }

    ngAfterViewInit() {
        // console.log('ModelComponent(' + this.myModel.id + ').ngAfterViewInit() is called!');
        //this.jsPlumbService.initModel(this.myModel);
        //this.jsPlumbService.init();
        //this.populateTables();
    }

    ngAfterViewChecked() {
        //console.log('AppComponent.ngAfterViewChecked() is called!');
        //this.populateTables();
        if (this.dataService.flg_repaint) {
            this.dataService.flg_repaint = false;
            this.jsPlumbService.repaintEverything();
        }
    }

    async ngOnInit() {
        this.jsPlumbService.init();
        //this.createConnection();
        //this.createModel(this.table);
        this.populateTables();
        //this.jsPlumbService.createConnection(this.data.getModelByName(this.databaseConnectionName), this.data.getModelByName(this.table['tableName']));
        // const temp = {
        //     source: this.data.getModelByName(this.databaseConnectionName),
        //     target: this.data.getModelByName(this.table['tableName'])
        // };
        // this.data.relations.push(temp);
    }

    createConnection() {
        this.data = new Data();
        this.dataService.data = this.data;
        this.myModel = new Model();
        this.myModel.name = this.databaseConnectionName;
        this.myModel.model_type = 'connection';
        this.myModel.display_name = this.databaseConnectionName;
        this.myModel.use_soft_delete = false;
        this.myModel.pos_x = this.pos_x;
        this.myModel.pos_y = this.pos_y;
        this.myModel.id = this.data.getNewModelId();

        this.data.models.push(this.myModel);
    }

    createModel(table, belongsTo, type) {
        this.myModel = new Model();
        if (this.id !== 0 && this.id % 5 === 0) {
            this.pos_x = 10;
            this.pos_y = this.pos_y + 300;
        }
        this.myModel.name = table['tableName'];
        this.myModel.model_type = 'table';
        this.myModel.display_name = table['tableName'];
        this.myModel.belongsTo = belongsTo;
        this.myModel.use_soft_delete = false;
        this.myModel.pos_x = this.pos_x + 500;
        this.myModel.pos_y = this.pos_y;

        if (type === 'table') {
            for (const field of table['fields']) {
                let schema = new Schema();
                schema.name = field['attributeName'];
                schema.display_name = field['attributeName'];
                schema.type = field['type'];
                schema.input_type = 'text';
                schema.unique = field['required'];
                schema.parent_id = this.myModel.id;
                this.myModel.schemas.push(schema);
            }
        }else{
            for (const field of table['columns']) {
                let schema = new Schema();
                schema.name = field['attributeName'];
                schema.display_name = field['attributeName'];
                schema.type = field['type'];
                schema.input_type = 'text';
                schema.unique = field['required'];
                schema.parent_id = this.myModel.id;
                this.myModel.schemas.push(schema);
            }
        }


        this.models.push(this.myModel);
        //this.dataService.addModel(this.myModel);
        this.myModel.id = this.data.getNewModelId();
        this.data.models.push(this.myModel);
        this.pos_y = this.pos_y + 300;
        this.id = this.id + 1;
    }


    createView() {
        this.myModel = new Model();
        if (this.id !== 0 && this.id % 5 === 0) {
            this.pos_x = 10;
            this.pos_y = this.pos_y + 300;
        }
        this.myModel.name = this.view['TABLE_NAME'];
        this.myModel.model_type = 'table';
        this.myModel.display_name = this.view['TABLE_NAME'];
        this.myModel.belongsTo = this.databaseConnectionName;
        this.myModel.use_soft_delete = false;
        this.myModel.pos_x = this.pos_x + 350;
        this.myModel.pos_y = this.pos_y;


        for (const field of this.view['columns']) {
            let schema = new Schema();
            schema.name = field['attributeName'];
            schema.display_name = field['attributeName'];
            schema.type = field['type'];
            schema.input_type = 'text';
            schema.unique = field['required'];
            schema.parent_id = this.myModel.id;
            this.myModel.schemas.push(schema);
        }

        this.models.push(this.myModel);
        //this.dataService.addModel(this.myModel);
        this.myModel.id = this.data.getNewModelId();
        this.data.models.push(this.myModel);
        this.pos_x = this.pos_x + 200;
        this.id = this.id + 1;
    }

    populateTables() {
        this.createConnection();
        if (this.type === 'view') {
            this.createView();
            for (const table of this.view['dependencies']) {
                this.createModel(table, this.view['TABLE_NAME'], 'view');
            }
        } else {
            this.createModel(this.table, this.databaseConnectionName, 'table');
        }

        //this.createModel(this.table, this.databaseConnectionName);
    }


}
